var _defs, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoutModern(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 17.8 21.29",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".d{stroke-width:1.29px;}.d,.e{fill:none;stroke:#888;stroke-miterlimit:10;}.f{fill:#888;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "a"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "b"
  }, /*#__PURE__*/React.createElement("g", {
    id: "c"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polyline", {
    className: "d",
    points: "14.29 7.84 16.89 10.44 14.29 13.04"
  }), /*#__PURE__*/React.createElement("line", {
    className: "d",
    x1: 16.89,
    y1: 10.44,
    x2: 9.97,
    y2: 10.44
  })), /*#__PURE__*/React.createElement("polyline", {
    className: "e",
    points: "12.4 12.75 12.4 19.42 4.05 19.58 4.05 1.46 12.4 1.3 12.4 8.15"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "f",
    points: "8.1 21.29 0 19.56 0 1.44 8.1 0 8.1 21.29"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoutModern);
export default __webpack_public_path__ + "static/media/logoutModern.0d389f5072f359a3a957e5bad84df0d3.svg";
export { ForwardRef as ReactComponent };